import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { CloudDownload, CloudUpload, Delete } from "@material-ui/icons";
import { useAuth, useAirborneAppConfig, useAccessControl } from "@airborne/react-admin";
import * as React from "react";
import { SelectInput, useNotify } from "react-admin";
import { Form } from "react-final-form";
import CustomLinearProgress from "../../Components/Progress/LinearProgress";
import { useAppDataProvider } from "../../dataprovider";
import ShopReportFileCreateModel from "./Model/ShopReportFileCreateModel";
import UploadButton from "./UploadButton";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PDFViewer = props => {
  const [url, setUrl] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [pdf, setPDF] = React.useState<any>({});
  const [pdfList, setPDFList] = React.useState([]);
  const [open, setOpen] = React.useState(props.open);
  const [loading, setLoading] = React.useState(false);
  const dataProvider = useAppDataProvider();
  const { tokens } = useAuth();
  const { apiBaseUrl } = useAirborneAppConfig();
  const notify = useNotify();
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl("vwshopreports");

  React.useEffect(() => {
    getPDFList();
  }, []);
  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);
  React.useEffect(() => {
    pdf.id > 0 && (pdf.isExternal ? base64toBlob() : getMinioPdf());
  }, [pdf]);

  const getPDFList = () => {
    setLoading(true);
    https: dataProvider
      .getDocumentsByRoNumber(props?.shopReport?.roNumber ?? -1, props?.shopReport?.wo ?? "")
      .then((result: any) => {
        const data = result?.data?.items || [];
        setPDFList(data || []);
        if (data.length > 0) {
          setPDF({ ...data[0] });
        } else {
          notify(`Data Not Found`, "warning", false, true);
        }
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  };
  const deleteShopFile = () => {
    dataProvider
      .deleteShopReportFile(pdf?.id ?? 0)
      .then(result => {
        notify(`Record Deleted`, "success", false, true);
        getPDFList();
        setPDF({});
      })
      .catch(error => {
        notify(`Error : ${error}`, "error", false, true);
      })
      .finally(() => {});
  };
  const CreateShopFile = (isDeleted, path = "") => {
    var createModel: ShopReportFileCreateModel = new ShopReportFileCreateModel();
    createModel.IsDeleted = isDeleted;
    createModel.Document = (pdf.document || props?.shopReport?.roNumber)?.toString?.();
    createModel.DocumentNo = pdf.documentNo || Number(`${new Date().getTime()}`.substring(5, 13));
    createModel.Item = pdf.item || 1;
    createModel.Path = path != "" ? path : pdf.path;
    createModel.ShopReportId = props?.shopReport?.id ?? 0;
    dataProvider
      .postShopReportFile(createModel)
      .then(result => {
        notify(`File has been added!`, "success", false, true);
        getPDFList();
        setPDF({});
      })
      .catch(result => {
        notify(`${result}`, "error", false, true);
      })
      .finally(() => {});
  };
  const getMinioPdf = () => {
    fetch(`${apiBaseUrl}/minio/download/${pdf.path}?token=${tokens?.accessToken}`)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        setUrl(url);
        var reader = new FileReader();
        reader.readAsBinaryString(blob);
        reader.onloadend = function () {
          const count = (reader.result as any)?.match?.(/\/Type[\s]*\/Page[^s]/g)?.length;
          setPageNumber(count);
        };
      })
      .catch(error => {
        notify("An error occured during download", "error");
        throw new Error(error);
      });
  };
  const base64toBlob = () => {
    const bytes: any = atob(pdf?.fileBase64);
    const count = bytes.match(/\/Type[\s]*\/Page[^s]/g)?.length;
    setPageNumber(count);
    let length = bytes?.length;
    let out = new Uint8Array(length);
    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }
    var blobData = new Blob([out], { type: "application/pdf" });
    const url = URL.createObjectURL(blobData);
    setUrl(url);
  };
  const handleDelete = () => {
    if (!pdf.isExternal) {
      deleteShopFile();
    } else {
      CreateShopFile(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };
  const handleDownload = () => {
    const link = document.createElement("a");
    link.download = `${new Date().getTime()}.pdf`;
    link.href = url;
    link.click();
  };
  const handleChange = event => {
    var tempPdf: any = pdfList.find(x => (x as any).id == event.target.value);
    setPDF({ ...tempPdf });
  };
  const handleFileChange = async ({ target }: any) => {
    const files: FileList = target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const {
        data: { objectKey },
      } = await dataProvider.uploadFileMinio(file);
      CreateShopFile(false, objectKey);
    }
  };
  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        {loading ? (
          <CustomLinearProgress loading={loading} periodTime={500} />
        ) : (
          <>
            <DialogTitle id="max-width-dialog-title">
              <Form
                onSubmit={() => {}}
                render={({ handleSubmit, form, values }) => {
                  return (
                    <form>
                      <SelectInput
                        onChange={handleChange}
                        defaultValue={pdf.id}
                        label="PDF List"
                        source="pdf"
                        choices={pdfList}
                        optionText="path"
                        optionValue="id"
                        fullWidth
                        variant="outlined"
                      />
                      <Grid container>
                        <Grid item xs={3}>
                          <Button
                            fullWidth
                            startIcon={<CloudDownload />}
                            onClick={handleDownload}
                            color="primary"
                            disabled={!(pdf?.id > 0)}
                          >
                            Download PDF
                          </Button>
                        </Grid>
                        {canCreate && (
                          <>
                            <Grid item xs={3}>
                              <Button
                                fullWidth
                                onClick={handleDelete}
                                startIcon={<Delete />}
                                color="primary"
                                disabled={!(pdf?.id > 0)}
                              >
                                Delete
                              </Button>
                            </Grid>
                            <Grid item xs={3}>
                              <UploadButton
                                handleChange={handleFileChange}
                                fullWidth
                                startIcon={<CloudUpload />}
                                color="primary"
                              />
                            </Grid>
                          </>
                        )}
                        <Grid item xs={3}>
                          <Button fullWidth onClick={handleClose} color="primary">
                            Close
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              />
            </DialogTitle>
            <DialogContent>
              {url != "" && pdf.id > 0 && (
                <div
                  style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Document file={url}>
                    {Array.from(new Array(pageNumber), (el, index) => (
                      <Page key={`page_${index + 1}`} height={window.innerHeight} pageNumber={index + 1} />
                    ))}
                  </Document>
                </div>
              )}
            </DialogContent>
            <DialogActions></DialogActions>
          </>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default PDFViewer;
